import { transformSearch } from "@/api/helper.ts";
import { queryClient } from "@/query-client.ts";
import { queryOptions, useMutation } from "@tanstack/react-query";
import { z } from "zod";
import caseMemberService from "./services/case-member-service";

export const caseMemberSearchSchema = z.object({
	search: z.string().optional(),
	include: z.string().optional(),
	page: z.number().nullable().optional(),
	case_id: z.string().nullable().optional(),
	case_record_id: z.string().nullable().optional(),
	role: z.string().optional(),
	per_page: z.number().optional(),
});

export const caseMembersQueryOptions = (search?: z.infer<typeof caseMemberSearchSchema>, options?: { enabled: boolean }) => {
	return queryOptions({
		queryKey: ["case_member", search],
		queryFn: () => caseMemberService.list(transformSearch(search, ["search", "case_id", "role"])),
		...options,
	});
};

export const casePartyMembersQueryOptions = (search?: z.infer<typeof caseMemberSearchSchema>, options?: { enabled: boolean }) => {
	return queryOptions({
		queryKey: ["case_counsels", search],
		queryFn: () => caseMemberService.listParty(transformSearch(search, ["search", "case_record_id", "role"])),
		...options,
	});
};
export const evidenceCasePartyMembersQueryOptions = (search?: z.infer<typeof caseMemberSearchSchema>, options?: { enabled: boolean }) => {
	return queryOptions({
		queryKey: ["case_members", search],
		queryFn: () => caseMemberService.listMultipleParties(transformSearch(search, ["search", "case_record_id", "role"])),
		...options,
	});
};

export const caseMemberQueryOptions = (caseMemberId: string) => {
	return queryOptions({
		queryKey: ["case_member", caseMemberId],
		queryFn: () => caseMemberService.findById(caseMemberId),
	});
};

export const useCaseMemberCreateMutation = (caseMemberId?: string) => {
	return useMutation({
		mutationKey: ["case_member", caseMemberId],
		mutationFn: caseMemberService.create,
		meta: {
			successMessage: "Case member created successfully",
		},
		onSuccess: () => queryClient.invalidateQueries({ queryKey: ["case_member"] }),
	});
};

export const useCaseMemberMutation = (caseMemberId?: string) => {
	return useMutation({
		mutationKey: ["case_member", caseMemberId],
		mutationFn: caseMemberService.upsert,
		meta: {
			successMessage: "Case member updated successfully",
		},
		onSuccess: () => queryClient.invalidateQueries({ queryKey: ["case_member"] }),
	});
};
